import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Base } from '@stepstone-genesis/components';
import { GradientBgTwoStep } from '../../../assets/GradientBgTwoStep.js';
export const GradientBackground = () => {
    return (_jsx(Base, { sx: {
            position: 'absolute',
            inset: 0,
            zIndex: 'zIndex0',
            pointerEvents: 'none',
        }, children: _jsx(GradientBgTwoStep, {}) }));
};
//# sourceMappingURL=GradientBackground.js.map